import React, { useEffect, useRef, useState } from "react";
import {
  Button,
  ButtonGroup,
  Input,
  Card,
  CardHeader,
  CardBody,
  Row,
  Col,
  Table,
  Label
} from "reactstrap";
import BackupIcon from "@mui/icons-material/BackupOutlined";
import IconButton from "@mui/material/IconButton";
import Typography from "@mui/material/Typography";
import GetAppIcon from "@mui/icons-material/GetApp"; // For the download icon
import PrimaryExcelDownloadHandler from "./PrimaryExcelDownloadHandler";
import * as XLSX from "xlsx";
import ExcelJS from "exceljs";
import firebase from 'firebase';
import { db } from '../../MY_LOGIN_AND_SIGNUP/db/config';
import { useNavigate } from "react-router-dom";
import KeyboardBackspaceIcon from '@mui/icons-material/KeyboardBackspace';
import CircularProgress from '@mui/material/CircularProgress';


const AddQuiz = () => {
  const db = firebase.firestore();
  const [active, setActive] = useState(true); // State for toggle between QUIZ and QUESTIONS
  const [subject, setSubject] = useState();
  const [currentSubjectId, setCurrentSubjectId] = useState();
  const [CurrentSubjectCount, setCurrentSubjectCount] = useState(0);

  const [range, setRange] = useState({ start: "", end: "" });
  const [fileName, setFileName] = useState("");
  const [uploadedFile, setUploadedFile] = useState(null);
  const [topics, setTopics] = useState(['enviroment']);
  const [primaryLanguage, setPrimaryLanguage] = useState('');
  const [fetchSubject, setFetchSubject] = useState([]);
  const [SecondaryQuestion, setSecondaryQuestion] = useState();
  const [currentUser, setCurrentUser] = useState({});
  const [loading, setLoading] = useState(false);
  
  const navigate = useNavigate();
  // State for managing the name of the uploaded file
  const [secondaryFileName, setSecondaryFileName] = useState("");

  // Ref for the file input element
  const secondaryBrowseBtnRef = useRef(null);

  // State for managing the uploaded file
  const [secondaryUploadedFile, setSecondaryUploadedFile] = useState(null);


  const [sampleQuestions, setSampleQuestions] = useState([
    {
      question: "What is 2 + 2?",
      optionA: "3",
      optionB: "4",
      optionC: "5",
      optionD: "6",
      correct: "B",
      correctOptionExplanation:'No Explaination'
    }
  ]);

  useEffect(() => {
    getSubjectDetail()
    getCurrentUser()
  }, []);

  const getSubjectDetail = () => {
    db.collection("subjects")
    .where("primaryLanguages", "!=", null)
    .where("status", "==", 0)
      .get()
      .then((querySnapshot) => {
        const subjects = [];
        querySnapshot.forEach((doc) => {
          console.log(doc.data(), "isGet");
          subjects.push({ id: doc.id, ...doc.data() });
        });
        setFetchSubject(subjects);
      })
      .catch((error) => {
        console.error("Error fetching subjects: ", error);
      });
  };

      const getCurrentUser = () => {
          firebase.auth().onAuthStateChanged((user) => {
              if (user) {
                  db.collection('zSystemUsers')
                      .doc(user.uid)
                      .get()
                      .then((query) => {
                          let data = query.data();
                          console.log('currentuserData', data);
                          setCurrentUser({ isTeacher: data.isTeacher || false,createdBy:data._uniqueID,creatorName:data.firstname + " " +data.lastname });
                      });
              }
          });
      };

  const browseBtnRef = useRef();
    const notifi = useRef();

    const notify = (msg, err) => {
    // console.log('notify')
    let color = err == false ? 'success' : 'danger';
    let options = {
      type: color,
      place: 'tr',
      message: (
        <div>
          <div>
            <b>{err == false ? 'Sucess' : 'Error'}</b> -{msg}.
          </div>
        </div>
      ),
      icon: 'tim-icons icon-bell-55',
      autoDismiss: 6,
    };
    if (notifi.current) {
      notifi.current.notificationAlert(options);
    }
    // notification(options);
  };
  const createQuestionHandler = async (e) => {
    try {
      console.log(currentUser, "currentUser");

      console.log('selectedSubject', subject);

      console.log("Execution started. Sample questions:", sampleQuestions);

      if (!sampleQuestions || sampleQuestions.length === 0) {
        throw new Error("No questions available to upload!");
      }

      if(!subject){
        alert("Please select a subject!");
        return;
      }

      setLoading(true);

      // Prepare structured data for Firestore
      const structuredData = {};
      sampleQuestions.forEach((row, index) => {
        let {
          primaryLanguage,
          topic,
          question,
          optionA,
          optionB,
          optionC,
          optionD,
          correct,
          difficulty,
          correctOptionExplanation,
        } = row;

        console.log(row,"check 1 row");
        primaryLanguage = primaryLanguage.toLowerCase()?.trim();
        topic = topic?.trim();
        // Validate required fields
        if (!primaryLanguage || !topic || !question || !correct || !difficulty ) {
          console.warn(`Skipping invalid row at index ${index}:`, row);
          return;
        }

        const questionId = `${topic}-${index}`; // Unique question ID based on topic and row index

        if (!structuredData[questionId]) {
          console.log("isCheck value", CurrentSubjectCount, index);
          structuredData[questionId] = {
            topic,
            questionNumber: CurrentSubjectCount + 1 + index,
            subject, // Use subject from the parent state or context
            difficulty,
            questionLanguages: [primaryLanguage],
            primaryLanguage,
            createdAt: firebase.firestore.FieldValue.serverTimestamp(),
            primaryQuestion: question.toLowerCase().trim(),
            [primaryLanguage]: {
              question,
              options: [optionA, optionB, optionC, optionD],
              correctOption: correct,
              correctOptionExplanation
            },
            status: 0,
            ...currentUser
          };
        }
      });

      // Batch upload to Firestore
      const batchUploads = [];
      let count = 0;
      for (const questionId in structuredData) {
        const docRef = db.collection("QuestionsV2").doc(); // Automatically generate an ID
        console.log(docRef.id, 'docRef');
        batchUploads.push(
          docRef.set({
            ...structuredData[questionId],
            id: docRef.id,
          })
        );
        count++;
      }

      await Promise.all(batchUploads); // Wait for all uploads to finish
      console.log("Questions successfully uploaded to Firestore!");

      // Update the current subject's totalQuestions count
      if (!currentSubjectId) {
        throw new Error("currentSubjectId is not defined!");
      }

      const currentSubjectRef = db.collection("subjects").doc(currentSubjectId);
      console.log("Updating the subject document:", currentSubjectId);

      await currentSubjectRef.update({
        totalQuestions: firebase.firestore.FieldValue.increment(count), // Increment total questions by the number uploaded
        updatedAt: firebase.firestore.FieldValue.serverTimestamp(),
      });

      setLoading(false);

      console.log("Subject document successfully updated!");
      navigate('/admin/quiz');
    } catch (error) {
      setLoading(false);
      notify("Error in createQuestionHandler:", error);
      console.error("Error in createQuestionHandler:", error);
    }
  };


  const handleFileUpload = (e) => {
    const file = e.target.files[0];
    if (file) {
      setFileName(file.name);
      setUploadedFile(file);

      // Parse the file
      const reader = new FileReader();
      reader.onload = (event) => {
        const data = new Uint8Array(event.target.result);
        const workbook = XLSX.read(data, { type: "array" });

        // Assuming the first sheet contains the data
        const firstSheetName = workbook.SheetNames[0];
        const worksheet = workbook.Sheets[firstSheetName];

        // Convert the sheet data to JSON (header = 1 for first row as headers)
        const jsonData = XLSX.utils.sheet_to_json(worksheet, { header: 1 });
        console.log(jsonData,"jsonData");
        // Transform the data into the desired format
        const transformedData = jsonData.slice(1).reduce((acc, row) => {
          // Check if any required field is missing
          if (
            row[0] && row[1] && row[2] && row[3] &&
            row[4] && row[5] && row[6] && row[7] && row[9]
          ) {
            acc.push({
              primaryLanguage: row[0],
              topic: row[1],
              question: row[2],
              optionA: row[3],
              optionB: row[4],
              optionC: row[5],
              optionD: row[6],
              correct: row[7],
              correctOptionExplanation: row[8] ? row[8] : "",
              difficulty: row[9],
            });
          }
          return acc; 
        }, []);
        console.log(transformedData,"transformedData");

        // Set transformed data to state
        setSampleQuestions(transformedData);
      };

      reader.readAsArrayBuffer(file);
    }
  };

  const handleSecondaryFileUpload = (e) => {
    const file = e.target.files[0];
    console.log("fileUpload 1");
    if (file) {
      console.log("fileUpload 2");

      setSecondaryFileName(file.name); // Set the file name
      setSecondaryUploadedFile(file); // Save the file for further processing
      console.log("fileUpload 3");

      // Read the file content
      const reader = new FileReader();
      console.log("fileUpload 4");

      reader.onload = (event) => {
        const data = event.target.result;
        console.log("fileUpload 5");

        // Parse the Excel file content
        const workbook = XLSX.read(data, { type: "binary" });
        const sheetName = workbook.SheetNames[0]; // Get the first sheet name
        const sheet = workbook.Sheets[sheetName]; // Get the first sheet
        const jsonData = XLSX.utils.sheet_to_json(sheet); // Convert sheet to JSON
        console.log("fileUpload 6");

        setSecondaryQuestion(jsonData);
        console.log("Excel Data:", jsonData); // Log the parsed data
      };
      reader.readAsBinaryString(file);
    }
  };

  const handleSecondarySubmit = async (e) => {
    e.preventDefault(); // Prevent default form submission behavior

    if (!secondaryUploadedFile || !SecondaryQuestion) {
      alert("Please upload a file before submitting.");
      return;
    }

    try {
      console.log("Processing secondary questions...");

      // Check if SecondaryQuestion contains valid data
      if (SecondaryQuestion.length === 0) {
        alert("The uploaded file is empty or invalid.");
        return;
      }

      // Initialize Firestore
      const db = firebase.firestore();

      // Iterate through each row in the parsed JSON data
      for (let index = 0; index < SecondaryQuestion.length; index++) {
        const {
          PrimaryLanguage,
          SecondaryLanguage,
          Topic,
          PrimaryQuestionID,
          PrimaryQuestion,
          SecondaryQuestion: secondaryQuestion,
          PrimaryOptionA,
          SecondaryOptionA,
          PrimaryOptionB,
          SecondaryOptionB,
          PrimaryOptionC,
          SecondaryOptionC,
          PrimaryOptionD,
          SecondaryOptionD,
          IsCorrect,
          CorrectOptionExplanation, // Updated key
          SecondaryCorrectOptionExplanation,
        } = SecondaryQuestion[index];

        console.log(`Processing question at index ${index}:`, SecondaryQuestion[index]);

        // Validate mandatory fields
        if (!PrimaryQuestionID || !secondaryQuestion || !SecondaryOptionA || !SecondaryOptionB || !SecondaryOptionC || !SecondaryOptionD) {
          console.warn(`Skipping row ${index + 1} due to missing mandatory fields.`);
          continue;
        }

        // Reference the document in Firestore
        const docRef = db.collection("QuestionsV2").doc(PrimaryQuestionID);

        // Prepare Firestore update object
        const updateData = {
          [SecondaryLanguage]: {
            correctOption: IsCorrect,
            options: [SecondaryOptionA, SecondaryOptionB, SecondaryOptionC, SecondaryOptionD],
            question: secondaryQuestion,
            correctOptionExplanation: SecondaryCorrectOptionExplanation || "" 
          },
          questionLanguages: firebase.firestore.FieldValue.arrayUnion(SecondaryLanguage),
        };

        // Update Firestore with the secondary question details
        await docRef.update(updateData);

        console.log(`Updated question with ID: ${PrimaryQuestionID}`);
      }

      navigate('/admin/quiz');
      alert("Secondary questions updated successfully!");
    } catch (error) {
      console.error("Error updating secondary questions:", error);
      alert("Something went wrong! Please Check the file format or data.");
    }
  };

  const getQuiz = () => {
    console.log("Fetching QUIZ data...");
  };

  const getQuestions = () => {
    console.log("Fetching QUESTIONS data...");
  };

  // Function to simulate CSV download
  const downloadSecondaryExcel = async (range, secondaryLanguage, subject) => {
    try {
      const db = firebase.firestore();
console.log(subject,"pxl down ");
      // Fetch data from Firestore
      const querySnapshot = await db
        .collection("QuestionsV2")
        .where("questionNumber", ">=", parseInt(range.start))
        .where("questionNumber", "<=", parseInt(range.end))
        .where("status", "==", 0)
        .where("subject", "==", subject)
        .orderBy("questionNumber")
        .get();

      const filteredData = querySnapshot?.docs?.map((doc) => ({
        id: doc.id,
        ...doc.data(),
      }));

      console.log(filteredData, "filteredData");
      if (filteredData.length === 0) {
        alert("No questions found for the given criteria.");
        return;
      }

      // Create a new Excel workbook and worksheet
      const workbook = new ExcelJS.Workbook();
      const worksheet = workbook.addWorksheet("Secondary Language Update");

      // Add headers
      worksheet.getCell("A1").value = "PrimaryLanguage";
      worksheet.getCell("B1").value = "SecondaryLanguage";
      worksheet.getCell("C1").value = "Topic";
      worksheet.getCell("D1").value = "PrimaryQuestionID";
      worksheet.getCell("E1").value = "PrimaryQuestion";
      worksheet.getCell("F1").value = "SecondaryQuestion";
      worksheet.getCell("G1").value = "PrimaryOptionA";
      worksheet.getCell("H1").value = "SecondaryOptionA";
      worksheet.getCell("I1").value = "PrimaryOptionB";
      worksheet.getCell("J1").value = "SecondaryOptionB";
      worksheet.getCell("K1").value = "PrimaryOptionC";
      worksheet.getCell("L1").value = "SecondaryOptionC";
      worksheet.getCell("M1").value = "PrimaryOptionD";
      worksheet.getCell("N1").value = "SecondaryOptionD";
      worksheet.getCell("O1").value = "IsCorrect";
      worksheet.getCell("P1").value = "CorrectOptionExplanation";
      worksheet.getCell("Q1").value = "SecondaryCorrectOptionExplanation";

      // Fill the data
      filteredData.forEach((doc, index) => {
        const { topic, id, primaryLanguage, [primaryLanguage]: primaryData = {} } = doc;

        const rowIndex = index + 2; // Start from the second row

        worksheet.getCell(`A${rowIndex}`).value = primaryLanguage || "N/A";
        worksheet.getCell(`B${rowIndex}`).value = secondaryLanguage;
        worksheet.getCell(`C${rowIndex}`).value = topic || "";
        worksheet.getCell(`D${rowIndex}`).value = id || "";
        worksheet.getCell(`E${rowIndex}`).value = primaryData.question || "";
        worksheet.getCell(`F${rowIndex}`).value = ""; // Secondary question (to be filled)
        worksheet.getCell(`G${rowIndex}`).value = primaryData.options?.[0] || "";
        worksheet.getCell(`H${rowIndex}`).value = ""; // Secondary Option A
        worksheet.getCell(`I${rowIndex}`).value = primaryData.options?.[1] || "";
        worksheet.getCell(`J${rowIndex}`).value = ""; // Secondary Option B
        worksheet.getCell(`K${rowIndex}`).value = primaryData.options?.[2] || "";
        worksheet.getCell(`L${rowIndex}`).value = ""; // Secondary Option C
        worksheet.getCell(`M${rowIndex}`).value = primaryData.options?.[3] || "";
        worksheet.getCell(`N${rowIndex}`).value = ""; // Secondary Option D
        worksheet.getCell(`O${rowIndex}`).value = primaryData.correctOption || "";
        worksheet.getCell(`P${rowIndex}`).value = primaryData.correctOptionExplanation || "";
        worksheet.getCell(`Q${rowIndex}`).value =  "";
      });



      // Download the file
      const buffer = await workbook.xlsx.writeBuffer();
      const blob = new Blob([buffer], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });
      const link = document.createElement("a");
      link.href = URL.createObjectURL(blob);
      link.download = `${subject}_secondary_language_update.xlsx`;
      link.click();

      alert("Excel file downloaded successfully!");
    } catch (error) {
      console.error("Error generating Excel file:", error);
      alert("An error occurred while generating the Excel file.");
    }
  };

  console.log('primaryLanguage33', primaryLanguage);

  return (
    <div className="content">
      <Row>
        <Col md="12">
          <Card>
            <CardHeader>
              <Row>
                <Col sm={6}>
                <div>
                    <button
                      onClick={() => navigate('/admin/quiz')}
                      style={{
                        marginRight: '4px',
                        color: 'white',
                        border: '0',
                        padding: '0 ',
                        outline: 'none',
                        background: 'transparent',
                        cursor: 'pointer',
                        marginBottom: '15px'
                      }}
                    >
                      <KeyboardBackspaceIcon style={{ fontSize: '35px', marginRight: '12px' }} />
                    </button>
                    <b/>
                     <ButtonGroup>
                    <Button
                      className={active ? "data" : "btn-simple data"}
                      color="info"
                      size="sm"
                      onClick={() => {
                        setActive(true);
                        getQuiz();
                      }}
                    >
                      <span className="d-none d-sm-block d-md-block d-lg-block d-xl-block">
                        Primary
                      </span>
                      <span className="d-block d-sm-none">
                        <i className="tim-icons icon-single-02" />
                      </span>
                    </Button>
                    <Button
                      className={!active ? "data" : "btn-simple data"}
                      color="info"
                      size="sm"
                      onClick={() => {
                        setActive(false);
                        getQuestions();
                      }}
                    >
                      <span className="d-none d-sm-block d-md-block d-lg-block d-xl-block">
                        Secondary
                      </span>
                      <span className="d-block d-sm-none">
                        <i className="tim-icons icon-gift-2" />
                      </span>
                    </Button>
                  </ButtonGroup>
                </div>
               
                </Col>

                <Col sm={6} className="d-flex justify-content-end">
                  {!active ? (
                    <>

                    </>
                  ) : (
                    <Button
                      color="info"
                      disabled={(!subject)?true:false}
                      onClick={() => {
                        PrimaryExcelDownloadHandler(subject, topics, primaryLanguage)
                      }}
                      style={{ display: 'flex', alignItems: 'center' }}
                    >
                      Primary Template
                      <GetAppIcon style={{ color: 'white', marginLeft: '10px' }} />
                    </Button>
                  )}
                </Col>
              </Row>
            </CardHeader>
            {!active ?
              <CardBody>
                <Row className="mb-4">
                  <Col md="12" className="mt-3">
                    <Label for="rangeStart">Enter Range of Questions</Label>
                    <div className="d-flex align-items-center gap-3 flex-wrap">
                      {/* Subject Selection */}
                      <select
                        id="subject"
                        className="form-control"
                        value={subject || ""}
                        onChange={(e) => {
                          const selectedValue = e.target.value;
                          const selectedSubject = fetchSubject?.find((val) => val.name === selectedValue);

                          setSubject(selectedValue);
                          console.log("pxl selectedSubject", selectedSubject);

                          // Update primary language or reset it if no match found
                          setPrimaryLanguage(selectedSubject?.primaryLanguages || "");
                        }}
                        style={{
                          maxWidth: "200px",
                          height: "40px",
                          border: "1px solid #2A344E",
                          borderRadius: "4px",
                          padding: "5px 10px",
                          marginRight: "10px",
                        }}
                      >
                        <option value="">-- Select Subject --</option>
                        {fetchSubject?.map((val) => (
                          <option key={val.id} value={val.name}>
                            {val.name}
                          </option>
                        ))}
                      </select>

                      {/* Primary Language Selection */}
                      <select
                        id="primaryLanguages"
                        className="form-control"
                        value={primaryLanguage || ""}
                        onChange={(e) => setPrimaryLanguage(e.target.value)}
                        style={{
                          maxWidth: "200px",
                          height: "40px",
                          border: "1px solid #2A344E",
                          borderRadius: "4px",
                          padding: "5px 10px",
                          marginRight: "10px",
                        }}
                      >
                        <option value="">-- Select Secondary Language --</option>
                        {subject &&
                          fetchSubject
                            ?.find(val => val.name === subject)
                            ?.languages
                            ?.filter(lang => lang !== fetchSubject.find(val => val.name === subject)?.primaryLanguages)
                            .map((lang, index) => (
                              <option key={index} value={lang}>
                                {lang}
                              </option>
                            ))}
                      </select>

                      {/* Range Inputs */}
                      <Input
                        type="number"
                        id="rangeStart"
                        placeholder={primaryLanguage ? "Start Range" : "Select a language first"}
                        value={range.start || ""}
                        onChange={(e) => setRange({ ...range, start: e.target.value })}
                        disabled={!primaryLanguage} // Disable until primary language is selected
                        style={{
                          maxWidth: "150px",
                          marginRight: "10px",
                          opacity: primaryLanguage ? "1" : "0.6", // Visual cue for disabled
                        }}
                      />

                      <Input
                        type="number"
                        id="rangeEnd"
                        placeholder={primaryLanguage ? "End Range" : "Select a language first"}
                        value={range.end || ""}
                        onChange={(e) => setRange({ ...range, end: e.target.value })}
                        disabled={!primaryLanguage} // Disable until primary language is selected
                        style={{
                          maxWidth: "150px",
                          marginRight: "10px",
                          opacity: primaryLanguage ? "1" : "0.6", // Visual cue for disabled
                        }}
                      />

                      {/* Download Button */}
                      <Button
                        color="info"
                        style={{
                          padding: "7px 20px",
                          whiteSpace: "nowrap",
                          backgroundColor:
                            range.start && range.end && primaryLanguage && subject
                              ? "#17a2b8"
                              : "#d6d6d6", // Conditional color
                          borderColor:
                            range.start && range.end && primaryLanguage && subject
                              ? "#17a2b8"
                              : "#d6d6d6", // Matching border
                          cursor:
                            range.start && range.end && primaryLanguage && subject
                              ? "pointer"
                              : "not-allowed", // Disable cursor
                        }}
                        disabled={!range.start || !range.end || !primaryLanguage || !subject} // Disable when incomplete
                        onClick={() => {
                          if (range.start && range.end && primaryLanguage && subject) {
                            downloadSecondaryExcel(range, primaryLanguage, subject); 
                          }
                        }}
                      >
                        Download CSV
                      </Button>
                    </div>

                  </Col>
                </Row>

                <Card>
                  <CardBody>
                    <Row>
                      <Col md="12">
                        <div className="uploadFileContainer" style={{ textAlign: "center" }}>
                          <IconButton onClick={() => secondaryBrowseBtnRef.current.click()}>
                            <BackupIcon style={{ fontSize: 70, color: "#007bff" }} />
                          </IconButton>
                          <Typography
                            variant="subtitle1"
                            style={{ fontWeight: "normal", margin: "10px 0" }}
                          >
                            {secondaryFileName ? secondaryFileName : "Click here to browse Excel file"}
                          </Typography>
                          <Button
                            style={{
                              padding: "10px 55px",
                              margin: "10px 5px",
                              backgroundColor: "#007bff",
                              color: "#fff",
                            }}
                            onClick={() => secondaryBrowseBtnRef.current.click()}
                          >
                            Browse
                          </Button>

                          <input
                            type="file"
                            accept=".xls,.xlsx"
                            ref={secondaryBrowseBtnRef}
                            style={{ display: "none" }}
                            onChange={handleSecondaryFileUpload}
                          />
                        </div>
                      </Col>
                    </Row>
                  </CardBody>
                </Card>
{
                  secondaryFileName?
                <Button
                  color="info"
                  style={{ padding: "7px 13px", marginTop: "15px" }}
                  onClick={handleSecondarySubmit}
                >
                  Submit Secondary Questions
                </Button>:''
                }


              </CardBody> : <CardBody>
                <Row className="mb-4">
                  <Col md={6}>
                    <div style={{ display: "flex", gap: "20px" }}>

                      <span style={{ marginLeft: '20px' }}>
                        <Label for="subject1" style={{ fontWeight: "bold", marginBottom: "5px", display: "block" }}>
                          Select Subject
                        </Label>
                        <select
                          type="select"
                          id="subject1"
                          className="form-control"
                          value={subject}
                          onChange={(e) => {
                            const selectedValue = e.target.value;
                            const selectedSubject = fetchSubject.find(
                              (val) => val.name === selectedValue
                            );
                            setSubject(selectedValue);
                            
                            setPrimaryLanguage(selectedSubject?.primaryLanguages || "");
                            setTopics(selectedSubject?.topics);
                            console.log(selectedSubject, "pxl subject");
                            setCurrentSubjectId(selectedSubject?.id)
                            setCurrentSubjectCount(selectedSubject?.totalQuestions || 0)
                          }}
                          style={{
                            maxWidth: "200px",
                            height: "40px",
                            border: "1px solid rgb(42.67, 52.71, 82.83)",
                            borderRadius: "4px",
                            padding: "5px 10px",
                            // background:'#27293d'
                          }}
                        >
                          <option value="">-- Select Subject --</option>
                          {fetchSubject?.map((val) => (
                            <option key={val.id} value={val.name}>
                              {val.name}
                            </option>
                          ))}
                        </select>
                      </span>
                      {
                        primaryLanguage ?
                          <span>
                            <Label for="primaryLanguage" style={{ fontWeight: "bold", marginBottom: "5px", display: "block" }}>
                              Primary language
                            </Label>
                            <Input
                              type="select"
                              id="primaryLanguage"
                              className="form-control"
                              value={primaryLanguage}
                              style={{
                                border: "1px solid rgb(42.67, 52.71, 82.83)",
                                borderRadius: "4px",
                                height: "40px",
                                padding: "5px 10px",
                                width: "200px",
                              }}
                            >
                              <option value={primaryLanguage}>{primaryLanguage}</option>
                            </Input>
                          </span> : ""
                      }
                    </div>
                  </Col>
                </Row>


                <Card>
                  <CardBody>
                    <Row>
                      <Col md="12">
                        <div className="uploadFileContainer" style={{ textAlign: "center" }}>
                          <IconButton onClick={() => browseBtnRef.current.click()}>
                            <BackupIcon style={{ fontSize: 70, color: "#007bff" }} />
                          </IconButton>
                          <Typography
                            variant="subtitle1"
                            style={{ fontWeight: "normal", margin: "10px 0" }}
                          >
                            {fileName
                              ? fileName
                              : "Click here to browse Excel file"}
                          </Typography>
                          <Button
                            style={{
                              padding: "10px 55px",
                              margin: "10px 5px",
                              backgroundColor: "#007bff",
                              color: "#fff",
                            }}
                            onClick={() => browseBtnRef.current.click()}
                          >
                            Browse
                          </Button>
                          <input
                            type="file"
                            accept=".xls,.xlsx"
                            ref={browseBtnRef}
                            style={{ display: "none" }}
                            onChange={handleFileUpload}
                          />
                        </div>
                      </Col>
                    </Row>
                  </CardBody>
                </Card>

                {uploadedFile && (
                  <Row>
                    <Col md="12">
                      <div style={{ maxHeight: "400px", overflowY: "auto" }}>
                        <Table className="tablesorter">
                          <thead className="text-primary">
                            <tr>
                              <th>Question</th>
                              <th>Option A</th>
                              <th>Option B</th>
                              <th>Option C</th>
                              <th>Option D</th>
                              <th>Correct Answer</th>
                            </tr>
                          </thead>
                          <tbody>
                            {sampleQuestions?.map((q, index) => (
                              <tr key={index}>
                                <td className={primaryLanguage == 'हिंदी' ? "hinditext" : ""} dangerouslySetInnerHTML={{ __html: q.question }}></td>
                                <td className={primaryLanguage == 'हिंदी' ? "hinditext" : ""} dangerouslySetInnerHTML={{ __html: q.optionA }}></td>
                                <td className={primaryLanguage == 'हिंदी' ? "hinditext" : ""} dangerouslySetInnerHTML={{ __html: q.optionB }}></td>
                                <td className={primaryLanguage == 'हिंदी' ? "hinditext" : ""} dangerouslySetInnerHTML={{ __html: q.optionC }}></td>
                                <td className={primaryLanguage == 'हिंदी' ? "hinditext" : ""} dangerouslySetInnerHTML={{ __html: q.optionD }}></td>
                                <td>{q.correct}</td>
                              </tr>
                            ))}
                          </tbody>
                        </Table>
                      </div>
                    </Col>

                    {loading ? 

                      <Button
                      
                      disabled
                      style={{ padding: "7px 13px", marginTop: "5px", marginLeft: '20px' }}
                      onClick={()=>{}}
                    >
              
                        <div style={{ display: "flex", alignItems: "center" }}>
                          <CircularProgress size={20} style={{color:'white'}} />
                          <span style={{ marginLeft: "10px", color: "white" }}>Uploading...</span>
                        </div>
                  
                    </Button> : 


                     <Button
                      color="info"
                      style={{ padding: "7px 13px", marginTop: "5px", marginLeft: '20px' }}
                      onClick={createQuestionHandler}
                    >
               
                        Submit Questions
                      
                    </Button>
                  
                  }
                   
                  </Row>
                )}
              </CardBody>
            }
          </Card>
        </Col>
      </Row>
    </div>
  );
};

export default AddQuiz;
